import { createAsyncThunk } from '@reduxjs/toolkit';

import { LESSON_TYPES } from 'constants/common';

import { updateLessonStatusViaApi } from 'store/helpers/updateLessonStatusViaApi';

import * as api from 'api/methods';

import { getChangedPropertiesByKeys } from 'helpers/getChangedPropertiesByKeys';

import * as types from './types';

export const getLessonById = createAsyncThunk<any, any>(
  types.GET_LESSON_BY_ID,
  async ({ courseId, lessonId }: { courseId: string; lessonId: string }) => {
    if (!courseId) {
      const lesson = await api.getCatalogLessonById(lessonId);

      return lesson;
    }

    const lesson = await api.getCourseLessonById({ courseId, lessonId });

    return lesson;
  },
);

export const updateLessonStatusById = createAsyncThunk<any, any>(
  types.UPDATE_LESSON_STATUS_BY_ID,
  updateLessonStatusViaApi,
);

export const updateLessonById = createAsyncThunk<any, any>(
  types.UPDATE_LESSON_BY_ID,
  async ({
    lessonId,
    lessonType,
    data,
    changedPropertiesKeys,
  }: {
    lessonId: string;
    lessonType: any;
    data: any;
    changedPropertiesKeys: any;
  }) => {
    let changedLessonProperties = null;

    switch (lessonType) {
      case LESSON_TYPES.QUIZ: {
        const lesson = await api.updateQuizById({
          lessonId,
          data: getChangedPropertiesByKeys({
            data,
            keys: changedPropertiesKeys,
          }),
        });

        changedLessonProperties = getChangedPropertiesByKeys({
          data: lesson,
          keys: [...changedPropertiesKeys, 'updatedAt'],
        });

        break;
      }
      case LESSON_TYPES.CONNECTION_QUIZ: {
        const lesson = await api.updateConnectionQuizById({
          lessonId,
          data: getChangedPropertiesByKeys({
            data,
            keys: changedPropertiesKeys,
          }),
        });

        changedLessonProperties = getChangedPropertiesByKeys({
          data: lesson,
          keys: [...changedPropertiesKeys, 'updatedAt'],
        });

        break;
      }
      case LESSON_TYPES.THEORY_LESSON: {
        const lesson = await api.updateTheoryLessonById({
          lessonId,
          data: getChangedPropertiesByKeys({
            data,
            keys: changedPropertiesKeys,
          }),
        });

        changedLessonProperties = getChangedPropertiesByKeys({
          data: lesson,
          keys: [...changedPropertiesKeys, 'updatedAt'],
        });

        break;
      }
      case LESSON_TYPES.FIGMA_LESSON: {
        const lesson = await api.updateFigmaLessonById({
          lessonId,
          data: getChangedPropertiesByKeys({
            data,
            keys: changedPropertiesKeys,
          }),
        });

        changedLessonProperties = getChangedPropertiesByKeys({
          data: lesson,
          keys: [...changedPropertiesKeys, 'updatedAt'],
        });

        break;
      }
      case LESSON_TYPES.DIFFERENCE_LESSON: {
        const lesson = await api.updateDifferenceLessonById({
          lessonId,
          data: getChangedPropertiesByKeys({
            data,
            keys: changedPropertiesKeys,
          }),
        });

        changedLessonProperties = getChangedPropertiesByKeys({
          data: lesson,
          keys: [...changedPropertiesKeys, 'updatedAt'],
        });

        break;
      }
      case LESSON_TYPES.TWO_COLUMNS_LESSON: {
        const lesson = await api.updateTwoColumnsLessonById({
          lessonId,
          data: getChangedPropertiesByKeys({
            data,
            keys: changedPropertiesKeys,
          }),
        });

        changedLessonProperties = getChangedPropertiesByKeys({
          data: lesson,
          keys: [...changedPropertiesKeys, 'updatedAt'],
        });

        break;
      }
      case LESSON_TYPES.COLOR_MATCH_LESSON: {
        const lesson = await api.updateColorMatchLessonById({
          lessonId,
          data: getChangedPropertiesByKeys({
            data,
            keys: changedPropertiesKeys,
          }),
        });

        changedLessonProperties = getChangedPropertiesByKeys({
          data: lesson,
          keys: [...changedPropertiesKeys, 'updatedAt'],
        });

        break;
      }
    }

    return changedLessonProperties;
  },
);

export const removeLessonById = createAsyncThunk<any, any>(
  types.REMOVE_LESSON_BY_ID,
  async ({ courseId, lessonId }: { courseId: string; lessonId: string }) => {
    const lesson = api.removeCourseLessonById({ courseId, lessonId });

    return lesson;
  },
);
